import * as React from "react";

interface Props {
  style?: React.CSSProperties;
  className?: string;
}
export const ImageIcon: React.FC<Props> = ({ style = {}, className = "" }) => {
  return (
    <svg
      style={style}
      className={className}
      id="Capa_1"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path d="m428.5 151h-345l-22.5-30h-61v270h512v-270h-61zm-337.5 180h-30v-120h30zm60 0h-30v-120h30zm60 0h-30v-120h30zm60 0h-30v-120h30zm60 0h-30v-120h30zm60 0h-30v-120h30zm60 0h-30v-120h30z" />
      </g>
    </svg>
  );
};
